import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup} from '@angular/forms';
import {InsightsService} from '../../shared/services/insights.service';
import {PopularLinksService} from '../../shared/services/popular-links.service';
import {AlertService} from '../../shared/services/alert.service';
import {ImageCroppedEvent} from 'ngx-image-cropper';
import {forEach} from 'lodash';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
    selector: 'app-insights',
    templateUrl: './insights.component.html',
    styleUrls: ['./insights.component.scss']
})
export class InsightsComponent implements OnInit {
    showSearch = false;
    id: any;
    data: any;
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    insights = [];
    onFileChanged: any;
    viewContentData: any;
    modalType: any;
    imageChangedIconEvent: any;
    croppedIconImageEvent: any;
    croppedIconImage: any;
    sanitizedContent: SafeHtml;
    popularLinks: any = [];
    popularLinkForm: FormGroup;
    popularLinkSubmitting: any = false;
    popularLinkTypes = [
        {value: 'BLOG', label: 'Blog Details Page (After Content)'},
        {value: 'BLOG_INLINE_CTA', label: 'Blog Details Page (Above Inline Apply Button)'},
        {value: 'LOCATION_WISE_COLLEGE', label: 'Top Universities in India (Home Page)'},
        {value: 'COURSE_WISE_COLLEGE', label: 'Course Wise Colleges Home Page'}
    ];
    popularLinkPagination = {
        page: 1,
        total: null,
        perpage: 10,
        pages: null
    };

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private insightService: InsightsService,
                private popularLinksService: PopularLinksService,
                private alertService: AlertService,
                private sanitizer : DomSanitizer) {
        this.popularLinkForm = this.fb.group({
            'title': [''],
            'url': [''],
            'type': ['BLOG']
        });
    }

    ngOnInit(): void {
        this.refresh();
    }




    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-insight').toggleOpen();
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'category': [''],
            'heading': [''],
            'url':['']
        });
        this.get();

    }
    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({ page: 1, total: null, perpage: 15, pages: null });
            this.toggleSidebar();


        }
    }


    search() {
        const params = {
            'category': (this.searchForm.value && this.searchForm.value.category) ? this.searchForm.value.category : '',
            'heading': (this.searchForm.value && this.searchForm.value.heading) ? this.searchForm.value.heading : '',
            url: (this.searchForm && this.searchForm.value && this.searchForm.value.url) ? this.searchForm.value.url : ''

        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            category: (this.searchForm && this.searchForm.value && this.searchForm.value.category) ? this.searchForm.value.category : '',
            heading: (this.searchForm && this.searchForm.value && this.searchForm.value.heading) ? this.searchForm.value.heading : '',
            url: (this.searchForm && this.searchForm.value && this.searchForm.value.url) ? this.searchForm.value.url : ''

        };
        this.get(params);
    }

    edit(data) {

        this.data = data;
        this.toggleSidebar();
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.insights = [];
        this.insightService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.insights = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.insights = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }
    insightsInfoPage(data: any) {
        this.router.navigateByUrl('insights-info/' + data.id);
    }

    onFileChange(e, type, data) {
        this.onFileChanged = e;
        this.insightService.fileUploadAdmin({
            'type': type,
            'fileType': 'NORMAL',
            'insight_id': data.id
        }, this.onFileChanged).subscribe(data => {
            if (type === 'INSIGHT_BANNER') {
                if (data && data['data']) {
                    this.get();
                }
            }
            this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
        }, error => {
            this.alertService.showErrors('Something went wrong, please try again');
        });
    }

    openInsightBanner(data) {
        window.open(data['banner']['url'], '_blank');
    }

    openInsightCover(data) {
        window.open(data['cover']['url'], '_blank');
    }





    viewContent(contentTemplate: any, data: any) {
        this.modalType = 'INSIGHT_CONTENT';
        this.viewContentData = data;
        const cleaned = data.content
            ?.replace(/<pre[^>]*class="ql-syntax"[^>]*>\s*<\/pre>/g, '')
            .replace(/<pre[^>]*class="ql-syntax"[^>]*>/g, '')
            .replace(/<\/pre>/g, '')
            .replace(/<p[^>]*>(\s|&nbsp;|<\/?br[^>]*>)*<\/p>/gi, '')
            .trim();

        const decoded = this.decodeHTMLEntities(cleaned || '');

        const withFixedTables = this.fixTableStructure(decoded);

        this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(withFixedTables);
        this.modalService.open(contentTemplate, { size: 'lg' });
    }

    private fixTableStructure(html: string): string {
        return html.replace(/<table([^>]*)>([\s\S]*?)<\/table>/gi, (_, attrs, content) => {
            if (/<(thead|tbody)/i.test(content)) {
                return `<table${attrs}>${content}</table>`;
            }
            const rows = content.split(/<tr[^>]*>/i).filter(row => row.trim().length > 0);
            let processedContent = '';

            rows.forEach(row => {
                const cleanRow = row.replace(/<\/?tr[^>]*>/gi, '');
                if (/<th[^>]*>/i.test(cleanRow)) {
                    processedContent += `<thead><tr>${cleanRow}</tr></thead>`;
                } else {
                    processedContent += `<tbody><tr>${cleanRow}</tr></tbody>`;
                }
            });
            return `<table${attrs}>${processedContent}</table>`;
        });
    }

    private decodeHTMLEntities(html: string): string {
        const entities: {[key: string]: string} = {
            '&nbsp;': ' ',
            '&lt;': '<',
            '&gt;': '>',
            '&amp;': '&',
            '&quot;': '"',
            '&#39;': "'",
            '&#34;': '"'
        };

        return html.replace(/&(nbsp|lt|gt|amp|quot|#39|#34);/g, match => entities[match]);
    }





    imageIconCropped(event: ImageCroppedEvent) {
        this.croppedIconImageEvent = event;
        this.croppedIconImage = event.base64;
    }

    imageLoaded() {
        // show cropper
    }

    cropperReady() {
        // cropper ready
    }

    loadImageFailed() {
        // show message
    }

    fileChangeIconEvent(event: any): void {
        this.imageChangedIconEvent = event;
    }

    saveOnInsightIcon() {
        const params = {
            'type': 'INSIGHT_ICON',
            'insight_id': this.id,
            'fileType': 'BASE64'
        };
        this.insightService.fileUploadAdmin(params, this.croppedIconImage).subscribe(data => {
            if (data) {
                this.imageChangedIconEvent = undefined;
                this.modalService.dismissAll('');
                this.alertService.showSuccess({'title': 'success', 'message': 'Image successfully loaded'});
                this.get();
            }
        });
    }

    openInsightIconModal(content, id) {
        this.id = id;
        this.modalType = 'INSIGHT_ICON';
        this.modalService.open(content, {size: 'lg'});
    }

    openInsightIcon(data) {
        window.open(data['icon']['url'], '_blank');
    }




    updateStatus(status, data) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.insightService.updateStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }

    addInTopTen(status, data: any) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                active_ten: status
            };

            this.submitting = true;
            this.insightService.addInTop(data.id, params).subscribe(res => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }

    updateMain(status, data: any) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                main: status
            };

            this.submitting = true;
            this.insightService.updateMain(data.id, params).subscribe(res => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }


    delete(id) {
        this.insightService.delete(id).subscribe(data => {
            this.get()
        });
    }

    openPopularLinksModal(content) {
        this.modalType = 'POPULAR_LINKS';
        this.popularLinkForm.reset({title: '', url: '', type: 'BLOG'});
        this.popularLinkPagination.page = 1;
        this.getPopularLinks();
        this.modalService.open(content, {size: 'lg'});
    }

    onPopularLinkTypeChange() {
        this.popularLinkPagination.page = 1;
        this.getPopularLinks();
    }

    onPopularLinkPageChange(page) {
        this.popularLinkPagination.page = page;
        this.getPopularLinks();
    }

    getPopularLinks() {
        const type = this.popularLinkForm.value.type;
        const params: any = {
            page: this.popularLinkPagination.page,
            per_page: this.popularLinkPagination.perpage
        };
        if (type) {
            params.type = type;
        }
        this.popularLinksService.get(params).subscribe(data => {
            if (data && data['data']) {
                if (data['data'].length === 0 && data.current_page > 1) {
                    this.popularLinkPagination.page = data.current_page - 1;
                    this.getPopularLinks();
                    return;
                }
                this.popularLinks = data['data'];
                this.popularLinkPagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page
                };
            } else {
                this.popularLinks = [];
            }
        });
    }

    addPopularLink() {
        if (!this.popularLinkForm.value.title || !this.popularLinkForm.value.url || !this.popularLinkForm.value.type) {
            return;
        }
        this.popularLinkSubmitting = true;
        this.popularLinksService.create(this.popularLinkForm.value).subscribe(data => {
            this.popularLinkSubmitting = false;
            this.popularLinkForm.patchValue({title: '', url: ''});
            this.popularLinkPagination.page = 1;
            this.getPopularLinks();
        }, error => {
            this.popularLinkSubmitting = false;
        });
    }

    deletePopularLink(id) {
        this.popularLinksService.delete(id).subscribe(data => {
            this.getPopularLinks();
        });
    }

}
